import type { ApiService } from "@/domains/api/api-service"

import type { ClFarmApiData } from "./types"

export class ClFarmApiTransport {
  constructor(private apiService: ApiService) {}

  /**
   * Load all CL farms from API
   * Pure data loading - no state, no caching, no side effects
   */
  async loadClFarms(): Promise<ClFarmApiData[]> {
    const response = await this.apiService.getClSets()

    // Convert the record to an array of farm items
    const farms = Object.values(response) ?? []
    return farms as ClFarmApiData[]
  }
}
